<template>
  <div class="ic-form__k-08">
    <FormWrapper :validator="$v.form">
      <IcFormContactEmail v-model="form.email" />
      <IcFormContactMessage v-model="form.message" />
      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"
              :label="$t('label_agreement_checkbox')" content="form_agreement_k">
            </IcFormAgreements>
      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormContactK03 from "@/components/ic/form/contact/k_03";

export default {
  extends: IcFormContactK03,
  name: "IcFormContactK08",
  data() {
    return {
      form: {
        type: "k08",
        
      }
    };
  }
};
</script>

<style>
</style>
